import React from 'react';
export function TopBar() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div onClick={scrollToOffer} className="sticky top-0 z-50 w-full bg-brand-violet text-white py-2.5 px-4 text-center shadow-sm cursor-pointer hover:bg-[#5A2D7E] transition-colors duration-300" data-id="element-308">
      <p className="text-xs md:text-sm font-medium tracking-wide" data-id="element-309">
        ✨Oferta Especial✨ 50% OFF + 4 Bonos exclusivos GRATIS HOY
      </p>
    </div>;
}